<template>
  <v-app id="app">
    <v-content>
      <HelloWorld />
    </v-content>
    <!-- <v-footer>
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer> -->
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld
  },

  data: () => ({
    //
  })
};
</script>
<style>
#inspire {
  background-color: rgb(16, 2, 49);
}
</style>
